export const ru = {
    approver_for: 'Согласующий для',
    title: 'Изменить согласующего',
};
